module.exports = __webpack_public_path__ + "static/img/manual-32.93f34b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-32.png
// module id = 2lwO
// module chunks = 4